module.exports = {
  支付成功: '支払い完了',
  返回首页: 'ホームページへ',
  '如需帮助，请联系我们的邮箱：':
    'ご不明な点がございましたら、下記までお問い合わせください：',
  支付失败: '支払い失敗',
  继续充值: '次へ',
  '选择区服/角色': 'サーバー/キャラクターを選択',
  确认付款: 'お支払い',
  充值商品: '購入アイテム',
  请选择: '選んでください',
  商品赠送: 'おまけ商品',
  用户协议: '利用規約',
  隐私协议: 'プライバシー規約',
  支付方式: 'お支払方法',
  实际支付: '合計金額',
  立即充值: '今すぐチャージ',
  支付确认: '支払いの確認',
  '请确认是否支付完成？': '支払いが完了したかどうかをご確認ください。',
  继续支付: '次へ',
  支付完成: '支払い完了',
  取消支付: '支払中止',
  游戏账号删除协议: 'ゲームアカウント削除の規約',
  账号删除进程: 'アカウント削除手順',
  确定: '確認します',
  '我们为您做出如下特别说明：在删除本游戏的游戏账号后，除法律法规或本协议另有规定外，您在该游戏账号下的个人信息将进行删除或匿名化处理，且此前已关联该游戏账号的相关产品与服务将不再关联。该游戏账号一旦删除完成，将无法恢复，您无法再检索、继续使用、访问和召回，也无权要求我们找回个人信息，请您谨慎操作。前述个人信息包括但不限于头像、昵称、会员权益、等级/经验值等与游戏角色成长升级相关的所有数据、虚拟货币、虚拟道具等虚拟物品、聊天记录等内容。': '当社は、お客様に対して以下の特約を行います。本ゲームでゲームアカウントを削除した後、法令または本契約に別段の定めがある場合を除き、ゲームアカウントに基づくお客様の個人情報を削除または匿名化し、当該ゲームアカウントに従来関連していた関連商品およびサービスを関連付けなくなります。 ゲームアカウントの削除が完了すると、復元は不可能となり、お客様はゲームアカウントを取得し、継続して使用、アクセス、または呼び出すことができなくなります。また、お客様は当社に対して個人情報の回収を要求する権利を有しませんので、慎重に手続きを行ってください。 前述の個人情報には、アイコン、ニックネーム、会員特典、レベル/経験値、その他お客様のゲームキャラクターの成長およびレベルアップに関するすべてのデータ、仮想通貨、仮想小道具、その他の仮想アイテム、チャット記録、その他のコンテンツが含まれますが、これらに限定されるものではありません。',
  '1、账号必须事先绑定邮箱。删除账号需要用邮箱进行验证，确保是本人操作。': '1、先にメールアドレスの連携の必要があります。 アカウントの削除は、ご本人による操作であることをメールで確認する必要があります。',
  '2、游戏收益已结清或得到妥善处理：包括但不局限于游戏代币、道具、会员权益等收益。请您妥善处理，若未处理，视为您自愿放弃该等收益。': '2、ゲーム収益が決済または適切に処理されている：仮想通貨、道具、VIPとその他の収益を含むがこれに限定されない。 適切に対処してください。そうでない場合は、そのような収益を自主的に放棄したものとみなされます。',
  '3、账号无任何纠纷：包括投诉举报、被投诉举报、仲裁、诉讼等纠纷。': '3.アカウントには、報告されたクレーム、仲裁、訴訟、その他の紛争を含む、あらゆる紛争が存在しないこと。',
  '亲爱的玩家，在您正式开始下一步有关本游戏的删除游戏账号流程前，请您务必先行仔细阅读、充分理解并同意《删除游戏账号协议》（以下统称“本协议”）。您按照游戏内提示的删除游戏账号之操作流程进行删除账号申请或开始删除账号流程的，或者您勾选本删除游戏账号协议并开始下一步操作的，均视为您已经同意和遵守本协议全部内容。': '「プレイヤーの皆様、本ゲームに関するゲームアカウントを削除する前に、まずゲームアカウント削除規約（以下、総称して「本規約」といいます）を必ずお読みいただき、十分にご理解、ご同意ください。 ゲーム内の指示に従ってアカウント削除の手続きを開始した場合、または本規約を確認して次のステップに進んだ場合、お客様は本規約に全面的に同意し、遵守したものとみなされます。',
  有关删除游戏账号的其它详细规则及注意事项请点击查看: 'ゲームアカウントの削除に関する詳細なルールや注意事項については、こちらをご覧ください。',
  删除游戏账号协议: 'ゲームアカウント削除規約',
  '将删除的游戏账号：': '削除されるゲームアカウント',
  游戏账号: 'アカウント',
  游戏ID: 'ゲームID',
  失败原因: '失敗の原因',
  '亲爱的用户，为确保您的账号安全，请提供您账号绑定的邮箱验证码以供账号删除校验，该验证码仅用于本次验证使用': 'ユーザーの皆様へ、アカウントの安全性を確保するために、アカウント削除の確認に携帯番号の認証コードを提供してください、認証コードは今回の確認にのみ使用されます',
  邮箱: 'メールアドレス',
  验证码: '認証コード',
  请输入验证码: '認証コードを入力',
  获取验证码: '入手',
  请描述你除账号的原因: '削除の理由をご記入ください。',
  '为防止误操作，请您再次确认是否删除游戏账号并确认删除后的影响，该影响包括但不限于（具体详见：': '悪用防止のため、ゲームアカウントの削除の再確認と、削除による影響についてご確認ください（詳細は下記をご覧ください）。',
  '1.该账号一旦删除成功，您将无法登录、使用该游戏账号，且无法回复。除法律法规和《删除游戏账号协议》另有约定外，您在该游戏账号下的个人信息将进行删除或匿名化处理，且此前已关联该游戏账号的相关产品与服务将不再关联。该游戏账号一旦删除完成，将无法恢复，您无法再检索、继续使用、访问和召回，也无权要求我们找回个人信息，请您谨慎操作。': '1.アカウント削除が成功すると、ゲームアカウントへのログインや利用ができなくなり、データの復旧もできなくなります。 法令およびゲームアカウント削除規約により別途合意された場合を除き、ゲームアカウントに基づくお客様の個人情報は削除または匿名化され、これまでゲームアカウントと関連付けられていた商品およびサービスは関連づけられなくなります。 ゲームアカウントの削除が完了した後は、復元することはできず、お客様が個人情報を取得し、継続して使用、アクセス、または呼び出すことはできませんし、当社にお客様の個人情報の回収を求める権利もありませんので、慎重に手続きを行ってください。',
  '2.您确认知悉，删除游戏账号的，该账号在本游戏使用期间已产生及未来可能产生是所有游戏收益或权益将会被全部删除/清除。据此，也特别提示您，在您开始删除本游戏账号前请您妥善处理您的游戏收益或权益。否则，账号删除后，我们有权利对该账号下的全部收益或权益做删除/清除处理，因此产生的后果由您自行承担，前游戏收益或权益包括但不限于账号内剩余的所有游戏虚拟货币、虚拟道具及其它虚拟物品及增值服务。': '2.お客様は、ゲームアカウントを削除した場合、お客様がゲームの使用中に発生させた、または将来発生させる可能性のあるすべてのゲーム収益または権利が削除/消去されることを了承するものとします。 従って、アカウント削除を開始する前に、ゲーム収益や権利を処分していただくようお願いいたします。 お客様が削除を行わない場合、当社はアカウントに基づくすべてのゲーム収益または利益を削除/消去する権利を有し、お客様はアカウントに残っているすべてのゲーム仮想通貨、仮想小道具、その他の仮想商品および付加価値サービスを含むがそれに限定されません。削除してから生じるすべての結果についてはお客様が責任を負うものとします。',
  您的游戏角色将于: 'このアカウントの削除は',
  '完成删除。请注意，该账号删除有15日的冷静期(账号锁定期)。除法律法规规定和协议约定情形外 我们将在冷静期满后完成删除，删除或匿名化处理您的个人信息。': 'に完了します。 なお、アカウントの削除には、7日間の削除猶予期間が設けられています。 当社は、猶予期間の後、法令や契約による場合を除き、お客様の個人情報の削除、消去、匿名化を完了します。',
  '在此期间，请您不要登录和使用该账号，以确保删除的顺利完成，否则视为您撤销删除申请。': 'この期間中は、削除が正常に完了されるために、アカウントにログインして使用しないでください。もしそうでなければ、お客様は削除の要求を撤回したことに認定されます。',
  确认删除游戏账号: '消去',
  放弃删除: '諦めます',
  下一步: '次へ',
  这是个多余的账号: '余分なアカウントです',
  弃游不想再玩: 'もう遊びたくないです',
  需要换绑实名认证信息: '本人確認を変更する必要がある',
  其他: 'その他',
  我已详细阅读并满足删除账号条件: 'アカウント削除の条件を詳しく読み、条件を満たしています。',
  确认删除的游戏账号: '削除希望のアカウントを確認します',
  我已详细阅读并同意: '詳細を読んだ、同意します。',
  验证本账号绑定的邮箱: '該当アカウントと連携したメールアドレスの認証',
  选择删除的原因: '削除の理由を選んでください',
  再次确认是否删除游戏账号并确认删除后的影响: 'ゲームアカウント削除の再確認と削除による影響の確認',
  删除游戏账号申请提交成功: 'ゲームアカウントの削除依頼が正常に送信されました。',
  完成: '完成です',
  验证码发送成功: '認証コードが送信されましたので、ご確認ください。',
  '请先勾选【我已仔细阅读并满足账号删除条件】': '『アカウント削除条件を読んだ、同意します』にチェックを入れてください。',
  '请先勾选【我已阅读并同意': 'を読んだ、同意します』にチェックを入れてください。',
  账号删除申请失败: 'アカウント削除のリクエストに失敗しました',
  验证成功: '認証成功',
  请选择删除原因: '削除の理由を選んでください',
  用户的游戏账号未绑定邮箱: 'ユーザーのゲームアカウントはメールボックスにバインドされていません',
  游戏账号删除条件: 'ゲームアカウントの削除条件',
  需要解绑邮箱: 'メールのバインドを解除する必要があります',
  '请先勾选【我已阅读并同意《游戏账号删除协议》】': '『ゲームアカウント削除規約を読んだ、同意します』にチェックを入れてください。',
  购买中: '購入中',
  购买失败: '購入失敗',
  购买成功: '購入成功',
  全部: '全部',
  '订单号：': '注文番号:',
  '时间：': '時間:',
  '商品：': '商品:',
  '支付方式：': '決済方法:',
  '订单金额：': '注文金額:',
  '支付金额：': '支払額:',
  '钱包：': 'ウォレット:',
  '订单状态：': '注文状況:',
  '说明：': '説明:',
  '如有疑问，请联系客服': 'ご不明な点がございましたら、お問い合わせまでお問い合わせください。',
  下拉更新: 'ドロップダウンダウンで更新',
  松开更新: '放してから更新',
  更新中: '更新中',
  暂无数据: '現時点ではデータなし',
  '加载中……': '読み込み中 ......',
  储值记录: 'ゲーム購入履歴',

};



// WEBPACK FOOTER //
// ./src/common/lang/ja.js